module.exports = function() {
  return new Worker("/" + "3rdparty/Decoder.worker.4e54cf6fb8dbcaf766a1.js");
};